import { z } from 'zod';
import { requiredFieldError, validateExpense } from '../../helper';
import { amount, amountApplicable, optionalAmount } from './amount';
import { document } from './document';

const incomeDocument = z.object({
  documents: document.optional(),
  bankStatementToken: z
    .string({
      required_error: requiredFieldError(),
    })
    .trim()
    .optional(),
  bankStatementComplete: z.boolean().optional(),
  documentIds: z.array(z.string()).optional(),
});

const proofOfIncome = amount.and(incomeDocument);

export const mainIncome = z.object({
  primary: amount,
});
export const partnerIncome = z.object({
  partnerIncome: amountApplicable.superRefine((data, ctx) => validateExpense({ data, ctx })).optional(),
});

export const householdIncome = z.object({
  householdIncome: amountApplicable.superRefine((data, ctx) => validateExpense({ data, ctx })),
  isSkipPrimaryIncome: z.boolean().optional(),
});

export const householdIncomeWithDocuments = householdIncome.and(
  z.object({
    primary: incomeDocument.optional(),
    isSkipPrimaryIncome: z.boolean().optional(),
  }),
);

export const openBankingIncome = z.object({
  primary: proofOfIncome.and(optionalAmount).optional(),
  isSkipPrimaryIncome: z.boolean().optional(),
  isAdditionalIncome: z.boolean().optional(),
  isSkipAdditionalIncome: z.boolean().optional(),
  additional: proofOfIncome.and(optionalAmount).optional(),
});

export const income = z.object({
  primary: proofOfIncome.optional(),
  additional: proofOfIncome.optional(),
  isSkipPrimaryIncome: z.boolean().optional(),
  isAdditionalIncome: z.boolean().optional(),
  isSkipAdditionalIncome: z.boolean().optional(),
});
